<template>
  <div class="breadcrumb_wrap" :style="{ background: bgColor }">
    <div class="EC_width display_between">
      <ul class="set_breadcrumb">
        <li v-for="(item, index) in breadList" @click="crumbsJump(item.name)" :key="index">
          <a href="javascript:void(0)">{{ item.meta.breadcrumbTitle }}</a>
        </li>
      </ul>
      <div class="breadcrumb_search display_center_ud" v-if="searchTag">
        <div class="signWrap" v-if="sign" @click="listTag = !listTag">
          {{ secrchtext }}
          <span class="arrowBttom"></span>
          <ul class="tipsWrap" v-if="listTag">
            <li style="position: relative">
              <span class="arrowTop"></span>
            </li>
            <li class="tipsli" @click.stop="getlistData(item)" v-for="(item, index) in searchKeywords" :key="index">{{
              item.label }}</li>
          </ul>
        </div>
        <input type="text" name="" id="" value="" v-model="searchValue" :class="{ signActive: sign }" />

        <div class="ArrIcon" @click="search">
          <img src="/image/icon/fangdajingbai.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'breadcrumbPage',
  props: {
    searchTag: Boolean,
    bgColor: {
      type: String
    },
    sign: {
      type: Boolean,
      default: true
    },
    searchValue1: String
  },
  data() {
    return {
      listTag: false,
      searchValue: '',
      /**tianlianpei */
      // 搜索关键词下拉
      searValueKey: '1',
      searchKeywords: [
        { label: '全部', value: '1' },
        { label: '标题', value: '2' },
        { label: '标签', value: '3' },
        { label: '作者', value: '4' },
        { label: '单位', value: '5' },
        { label: '摘要', value: '6' }
      ],
      secrchtext: '全部',
      breadList: [] // 路由集合
    };
  },
  // computed: {
  //     routelist() {
  //         return (this.$route && this.$route.matched) || []
  //     },
  // },
  // beforeRouteEnter(to, from, next) {
  //     // 在渲染该组件的对应路由被 confirm 前调用
  //     // 不！能！获取组件实例 `this`
  //     // 因为当守卫执行前，组件实例还没被创建
  // },
  created() {
    this.getBreadcrumb();
  },

  mounted() {
    if (this.$route.params.labelname != '') {
      this.searchValue = this.$route.params.labelname;
    }
  },
  methods: {
    getlistData(info) {
      this.secrchtext = info.label;
      this.searValueKey = info.value;
      this.listTag = !this.listTag;
    },
    search() {
      let data = { value: this.searchValue, key: this.searValueKey };
      this.$emit('search', data);
    },
    isHome(route) {
      return route.name === 'home';
    },
    getBreadcrumb() {
      let matched = this.$route.matched;
      this.breadList = matched;
    },
    crumbsJump(name) {
      let routepath = this.$route.name;
      if (name == routepath) {
        return;
      } else if (name == 'home' || name == 'grassheal' || name == 'magazine' || name == 'disciconstruc') {
        this.$router.push({ name: name });
      }
      if (localStorage.getItem('Inforlist_param_' + parseInt(this.$route.query.column_Type))) {
        let Inforlist_param = JSON.parse(localStorage.getItem('Inforlist_param_' + parseInt(this.$route.query.column_Type)));
        this.$router.push({
          name: name,
          query: {
            pid: Inforlist_param.pid,
            title: Inforlist_param.title,
            cid: Inforlist_param.cid
          }
        });
      } else if (name == 'enLiteList2' || name == 'enLiteList3') {
        this.$router.push({
          name: name,
          query: {
            nian: this.$route.query.nian,
            qi: this.$route.query.qi
          }
        });
      } else if (name == 'enindex') {
        this.$router.push({ name: name });
      } else if (localStorage.getItem('magazinejournal_param_' + this.$route.query.nian)) {
        let magazinejournal_param_ = JSON.parse(localStorage.getItem('magazinejournal_param_' + this.$route.query.nian));
        this.$router.push({
          name: name,
          query: {
            nian: magazinejournal_param_.nian,
            qi: magazinejournal_param_.qi
          }
        });
      } else {
        this.$router.push({
          name: name, query: {
            nian: this.$route.query.nian,
            qi: this.$route.query.qi
          }
        });
      }
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  }
};
</script>

<style scoped>
.arrowBttom {
  border-style: solid;
  border-width: 6px;
  border-color: #000f15 transparent transparent transparent;
  position: absolute;
  top: 12px;
  right: 0;
}

.arrowTop {
  border-style: solid;
  border-width: 6px;
  border-color: transparent transparent #ccc transparent;
  position: absolute;
  top: -12px;
  left: 32px;
}

.breadcrumb_wrap {
  min-width: 1300px;
  list-style: none;
  height: 40px;
  background: #f2f2f2;
  display: flex;
}

.set_breadcrumb {
  list-style: none;
  line-height: 40px;
  height: 100%;
  padding: 0;
}

.set_breadcrumb li {
  display: inline-block;
  font-size: 12px;
  color: #0b8485;
}

.set_breadcrumb li~li:before {
  content: '>';
  margin-left: 4px;
  margin-right: 4px;
  color: #333;
}

.set_breadcrumb li a {
  display: inline-block;
  font-size: 12px;
  color: #333;
}

.breadcrumb_search input {
  width: 200px;
  height: 30px;
  box-sizing: border-box;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  outline: none;
  border: 1px solid #f2f2f2;
  padding-left: 10px;
}

.ArrIcon {
  display: inline-block;
  width: 50px;
  height: 30px;
  background: #0b8686;
  border-radius: 0 30px 30px 0;
  text-align: center;
  line-height: 34px;
  cursor: pointer;
  box-sizing: border-box;
}

.signWrap {
  padding: 0 18px;
  height: 30px;
  border: 1px solid #f2f2f2;
  border-right: none;
  box-sizing: border-box;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background: #fff;
  text-align: center;
  line-height: 30px;
  position: relative;
  cursor: pointer;
}

.breadcrumb_search .signActive {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.tipsWrap {
  width: 100px;
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
  border-radius: 4px;
  position: absolute;
  left: -10px;
  top: 40px;
  box-shadow: 0px 0px 3px #ccc;
}

.tipsli {
  height: 30px;
  text-align: center;
  cursor: pointer;
  line-height: 30px;
  position: relative;
}

.tipsli:hover {
  color: #0b8586;
}

.selectEl {
  width: 80px;
  height: 30px;
  box-sizing: border-box;
}

.selectClass {
  height: 30px !important;
  line-height: 30px !important;
}
</style>
